module.exports = __webpack_public_path__ + "ac873c1235050dea685f585abf5a2375.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/styles/img/organizations/hero_bg@3x.jpg
// module id = 662
// module chunks = 0